import { jwtDecode } from "jwt-decode";
import { LOCALSTORAGE_ACCESS_TOKEN } from "../api/constants/localStorageConstantes";

export function getAccessToken() {
  try {
    return localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN) || "";
  } catch {
    return "";
  }
}

export function clearAccessToken() {
  try {
    localStorage.removeItem(LOCALSTORAGE_ACCESS_TOKEN);
  } catch {}
}

export function setAccessToken(token) {
  try {
    localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, token);
  } catch {}
}

export function decodeAccessToken(token = getAccessToken()) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isAccessTokenValid(token = getAccessToken()) {
  const decoded = decodeAccessToken(token);
  if (!decoded || typeof decoded.exp !== "number") return false;
  return decoded.exp * 1000 > Date.now();
}

export function getAccountInfo() {
  return decodeAccessToken();
}
